import { METRIC_NAMES } from '@config/Consts';

class ConversationsModel {
  constructor(options) {
    this[METRIC_NAMES.AGENT_ID] = options[METRIC_NAMES.AGENT_ID];
    this[METRIC_NAMES.AGENT_NAME] = options[METRIC_NAMES.AGENT_NAME];
    this[METRIC_NAMES.VISITOR_NAME] = options[METRIC_NAMES.VISITOR_NAME];
    this[METRIC_NAMES.CONVERSATION_STATUS] = options[METRIC_NAMES.CONVERSATION_STATUS];
    this[METRIC_NAMES.CONVERSATIONS_RESPONSE_TIME] =
      options[METRIC_NAMES.CONVERSATIONS_RESPONSE_TIME];
    this[METRIC_NAMES.CONVERSATION_SKILL] = options[METRIC_NAMES.CONVERSATION_SKILL];
    this[METRIC_NAMES.MCS] = options[METRIC_NAMES.MCS];
    // this.duration = options.duration; // Remove duration
    this[METRIC_NAMES.CONVERSATION_ID] = options[METRIC_NAMES.CONVERSATION_ID];
    this[METRIC_NAMES.CONSUMER_ID] = options[METRIC_NAMES.CONSUMER_ID];
    this[METRIC_NAMES.CSAT] = options[METRIC_NAMES.CSAT];
    this[METRIC_NAMES.NPS] = options[METRIC_NAMES.NPS];
    this[METRIC_NAMES.CONVERSATION_START_TIME] = options[METRIC_NAMES.CONVERSATION_START_TIME];
    this[METRIC_NAMES.AGENT_GROUP] = options[METRIC_NAMES.AGENT_GROUP];
    this[METRIC_NAMES.BRAND_NAME] = options[METRIC_NAMES.BRAND_NAME];
    this[METRIC_NAMES.CONVERSATION_INTENTS] = options[METRIC_NAMES.CONVERSATION_INTENTS];
    this[METRIC_NAMES.DIALOGS] = options[METRIC_NAMES.DIALOGS];
    this[METRIC_NAMES.CLOSE_REASON] = options[METRIC_NAMES.CLOSE_REASON];
  }
}

export default ConversationsModel;
